import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { auth } from './firebase';
import './App.css';
import Login from './Login';
import Quizz from './Quizz';
import Navbar from './Navbar';
import Home from './Home';
import Learn from './Learn';
import Account from './Account';
import SectionNav from './SectionNav';
import Footer from './Footer';
import Privacy from './Privacy';
import Terms from './Terms';
import FAQ from './FAQ';
import Contact from './Contact';
import SpeedRun from './SpeedRun';

function Layout({ user, children }) {
  const location = useLocation();
  const isLearnPage = location.pathname === '/learn';

  return (
    <div className="App">
      {!isLearnPage && <Navbar user={user} />}
      <div className="main-content">
        {/* Render SectionNav only on the homepage */}
        {location.pathname === '/' && !isLearnPage && <SectionNav />}
        <header className="App-header">
          {children}
        </header>
      </div>
      {!isLearnPage && <Footer />}
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <span className="loading-title">
          <span>D</span>
          <span className="rotating">W</span>
          <span>A</span>
          <span>G</span>
        </span>
      </div>
    );
  }

  return (
    <Router>
      <Layout user={user}>
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/account" element={user ? <Account user={user} /> : <Login from="/account" />} />
          <Route path="/quizz" element={user ? <Quizz /> : <Login from="/quizz" />} />
          <Route path="/speedrun" element={user ? <SpeedRun /> : <Login from="/speedrun" />} />
          <Route path="/learn" element={user ? <Learn /> : <Login from="/learn" />} />
          <Route path="/login" element={<Login from="/" />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;